module.exports = __webpack_public_path__ + "static/media/exclamation.cf6ac04e.svg";